// extracted by mini-css-extract-plugin
module.exports = {"pageEmpty__content":"c2_q8","pageEmpty__image":"c2_q9","pageEmpty__text":"c2_rb"};